<template>
  <div class="description-wrapper">
    <p class="description-title">{{ title }}</p>
    <div class="grid-layout" :style="gridStyle">
      <div
        class="description-item"
        v-for="(item, index) in sourceData"
        :key="index"
      >
        <span class="description-label">{{ item.name }}</span>
        <span v-if="!$scopedSlots[item.label]" class="description-value">
          {{ item.value }}
        </span>
        <!-- 插槽内容 -->
        <slot v-else :name="item.label" :item="item">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'quote-grid-descriptions',
  props: {
    title: {
      type: String,
      default: '',
    },
    sourceData: {
      type: Array,
      default: () => [], //必须满足 [{name:'',value:'',label:""},...]的格式
    },
    column: {
      type: Number,
      default: 1, // grid布局列数，默认为1列
      validator: (value) => value > 0,
    },
  },
  data() {
    return {}
  },
  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.column}, 1fr)`,
      }
    },
  },
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.description-wrapper {
  .description-title {
    color: #222222;
    text-align: justify;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    margin-bottom: 16px;
  }
  .grid-layout {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 32px;
    .description-item {
      display: flex;
      // align-items: center;
      gap: 16px;
      margin-bottom: 8px;
      .description-label {
        width: 140px;
        color: #666666;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        line-height: 22px;
        flex-shrink: 0;
      }
      .description-value {
        flex: 1 0 0;
        color: #333333;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        line-height: 22px;
      }
    }
    .description-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
